import { Box, Chip, Typography, useTheme } from "@mui/material";
import { translationService } from "e.sic-platform.webclient/src/services/translation/TranslationService";
import { observer } from "mobx-react-lite";
import { SaridaCoin } from "e.sic-platform.webclient/src/components/svg/svgImageList";
import { useMemo } from "react";
import Svg from "e.sic-platform.webclient/src/components/svg/Svg";

export interface ICoinProps {
  style?: any;
  text?: string;
  amount?: number;
  withBorder?: boolean;
  color?: any;
}

export const Coin = observer(function Coin(props: ICoinProps) {
  const size = 29;
  const chipStyle = useMemo(() => {
    const style = {
      p: 1,
      borderRadius: 1,
      borderWidth: 2,
      borderStyle: "style",
    };
    return props.withBorder ? style : { ...style, border: "none" };
  }, [props.withBorder]);

  const CoinSymbol = () => {
    return (
      <Svg svg={SaridaCoin} style={{ width: size * 0.8, height: size * 0.8 }} />
    );
  };

  const RawCoin = () => {
    return (
      <Box display="flex" flexDirection="row" alignItems="center">
        {props.amount && (
          <Typography variant="body1" fontWeight="bold" sx={{ mr: 1 }}>
            {props.amount}
          </Typography>
        )}
        <Box display="flex" flexDirection="column" alignItems="center">
          <CoinSymbol />
        </Box>
      </Box>
    );
  };

  if (props.text)
    return (
      <Chip
        color={props.color ? props.color : "primary"}
        variant="outlined"
        deleteIcon={<RawCoin />}
        onDelete={() => {}}
        label={
          <Typography variant="body1" fontWeight="bold">
            {props.text}
          </Typography>
        }
        sx={chipStyle}
        size="medium"
      />
    );

  return <CoinSymbol />;
});
